export const roleNames = {
  MA: 'MA',
  SUPER_USER: 'Super User',
  SALES_CONSULTANT: 'Sales Consultant',
  MENU_CONSULTANT: 'Menu Consultant',
  CHEF: 'Chef',
  TECHNICAL_TEAM: 'Technical Team',
  DSM: 'District Sales Manager',
  RSM: 'Regional Sales Manager',
  SALES_ADMIN: 'Sales Admin',
  VP: 'Vp of Sales',
  GUEST: 'Guest',
  CUSTOMER: 'Customer',
  MULTI_BUYER: 'Multi Buyer',
  USER: 'USER',
}

export const userTypes = {
  EXTERNAL: 'external',
  INTERNAL: 'internal',
}

export const operatingCountries = {
  unitedStates: 'US',
  canada: 'CA',
};

export const allowedRoles = [
  roleNames.MA,
  roleNames.SUPER_USER,
  roleNames.SALES_CONSULTANT,
  roleNames.MENU_CONSULTANT,
  roleNames.CHEF,
  roleNames.TECHNICAL_TEAM,
  roleNames.DSM,
  roleNames.RSM,
  roleNames.SALES_ADMIN,
  roleNames.VP,
  roleNames.GUEST,
];

export const userPrivileges = {
  VSIBILITY_FOR_GMB_LINK: 1,
  INDESIGN_FILE_UPLOAD: 2,
  GBP_DIRECT_VERIFICATION: 3,
  ASSET_TRANSFER:4,
  RECIPE_EXCEL_UPLOAD: 5,
}